import { IUsersAPIState } from "../types/users.types";

export const USERS_INITIAL_STATE: IUsersAPIState = {
  data: [],
  pageProps: {
    isDescending: false,
    pageNumber: 0,
    perPage: 0,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedUser: {},
};
